import { isEmpty } from "lodash";
import { paths } from "./constants";
import { gotoUrl, handleRedirect } from "./helpers";

export const getWorkflow = async (channel, redirects) => {
  let workflowModule = [];
  try {
    workflowModule = await import(`@workflow/${channel}`);
    return workflowModule.default;
  } catch (error) {
    isEmpty(workflowModule)
      ? handleRedirect(redirects)
      : gotoUrl(paths.ERROR_404);
  }
};
